import type { ReactNode } from "react";
import { VStack } from "../../layout/stack";
import { cn } from "../../lib/utils";

export function MessageWrapper({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}): React.ReactElement {
	return (
		<VStack className={cn("rounded-message", "p-md", "gap-md", className)}>
			{children}
		</VStack>
	);
}
